import i18n from '@ohif/i18n';
import type { Button } from '@ohif/core/types';

// Use the same Chinese Buttons translations as cloud imaging. Resolve by tool
// ID because the shared pack may already have captured an English label at import.
const labelKeys: Record<string, string> = {
  modalityLoadBadge: 'Status',
  navigationComponent: 'Navigation',
  trackingStatus: 'Tracking Status',
  dataOverlayMenu: 'Data Overlay',
  orientationMenu: 'Orientation',
  windowLevelMenuEmbedded: 'Window Level',
  windowLevelMenu: 'Window Level',
  voiManualControlMenu: 'Advanced Window Level',
  thresholdMenu: 'Threshold',
  opacityMenu: 'Opacity',
  Colorbar: 'Colorbar',
  Reset: 'Reset View',
  Probe: 'Probe',
  Cine: 'Cine',
  Angle: 'Angle',
  CobbAngle: 'Cobb Angle',
  Magnify: 'Zoom-in',
  CalibrationLine: 'Calibration',
  AdvancedMagnify: 'Magnify Probe',
  UltrasoundDirectionalTool: 'Ultrasound Directional',
  WindowLevelRegion: 'Window Level Region',
  Length: 'Length',
  Bidirectional: 'Bidirectional',
  ArrowAnnotate: 'Annotation',
  EllipticalROI: 'Ellipse',
  RectangleROI: 'Rectangle',
  CircleROI: 'Circle',
  PlanarFreehandROI: 'Freehand ROI',
  SplineROI: 'Spline ROI',
  Pan: 'Pan',
  Zoom: 'Zoom',
  TrackballRotate: '3D Rotate',
  Crosshairs: 'Crosshairs',
  SegmentLabelTool: 'Segment Label Display',
};

const clinicalLabels: Record<string, string> = {
  WindowLevel: '窗宽窗位',
  MPR: '多平面重建',
  '3D': '三维重建',
};

export function localizeClinicalToolbar(buttons: Button[]): Button[] {
  const translate = i18n.getFixedT('zh', 'Buttons');
  return buttons.map(button => {
    if (!button.props) return button;
    const label =
      clinicalLabels[button.id] ||
      (labelKeys[button.id] ? translate(labelKeys[button.id]) : button.props.label);
    return {
      ...button,
      uiType: button.uiType === 'ohif.toolButtonList' ? 'clinical.toolButtonList' : button.uiType,
      props: {
        ...button.props,
        ...(label ? { label } : {}),
        ...(button.props.tooltip ? { tooltip: translate(button.props.tooltip) } : {}),
      },
    };
  });
}

export function localizeClinicalSeriesSorts<T extends { label: string }>(sorts: T[]): T[] {
  const translate = i18n.getFixedT('zh', 'StudyBrowser');
  return sorts.map(sort => ({ ...sort, label: translate(sort.label) }));
}
